import { MeetTheTeamPage } from "~/components/meet-the-team/MeetTheTeamPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/meet-the-team")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/meet-the-team"),
  component: MeetTheTeamPage,
});
